import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';

const I18N_BASE_PATH =
  'pages.private.KYBCompany.pages.companyDetails.subPages.people.creditReport';

const PreviousDirectors = ({ previousDirectorsList }) => {
  const { t: translate } = useTranslation();

  return (
    <div className="previous-director-list">
      <Row>
        <Col span={9} className="previous-director-column">
          {translate(
            `${I18N_BASE_PATH}.tabs.directors.previousDirectors.columns.name`,
            'Name'
          )}
        </Col>
        <Col span={1}>
          <div className="current" />
        </Col>
        <Col span={4} className="previous-director-column">
          {translate(
            `${I18N_BASE_PATH}.tabs.directors.previousDirectors.columns.currentActiveAppointments`,
            'Current Active Appointments'
          )}
        </Col>
        <Col span={1}>
          <div className="previous" />
        </Col>
        <Col span={4} className="previous-director-column">
          {translate(
            `${I18N_BASE_PATH}.tabs.directors.previousDirectors.columns.previousDirectorships`,
            'Previous Directorships'
          )}
        </Col>
        <Col span={1}>
          <div className="dissolved" />
        </Col>
        <Col span={4} className="previous-director-column">
          {translate(
            `${I18N_BASE_PATH}.tabs.directors.previousDirectors.columns.dissolvedDirectorships`,
            'Dissolved Directorships'
          )}
        </Col>
      </Row>
      <div className="mrg-btm-25" />
      {previousDirectorsList?.map((element) => (
        <Row key={element?.id} className="line">
          <Col span={9} className="director-name">
            {element?.name}
          </Col>
          <Col span={5} className="director-infos">
            {element?.additionalData?.presentAppointments}
          </Col>
          <Col span={5} className="director-infos">
            {element?.additionalData?.previousAppointments}
          </Col>
          <Col span={5} className="director-infos">
            {element?.additionalData?.dissolvedAppointments}
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default PreviousDirectors;
